/* TEST-009 — Cross-sell visibility router. TEST_MODE='live' default.
 * Arm A: hide cross-sells.
 * Arm B: move cross-sells to a 'demoted' slot near the bottom of the PDP.
 */
(function(){
  'use strict';
  var TEST_ID='pdp_cross_sell', COOKIE='cl_xsell_v', PARAM='cl_xsell_v', TTL=30;
  var SPLIT=[{a:'control',w:50},{a:'a',w:50}];
  var VALID={control:1,a:1};
  var TEST_MODE='smoke'; // 2026-05-26 rev2 — REVERT: test closed, all visitors get control
  // ─── Metafield override (rev2.5 — Wiki/Ecomm/Reports/cro-weekly-2026-05-26 §arch) ───
  // Read shop.metafields.cro.test_config['pdp_cross_sell'] from the page-global
  // emitted by snippets/cro-config-global.liquid. If present, REPLACE the
  // hardcoded SPLIT + VALID below so weight changes via Scripts/cro_config.py
  // take effect on next page load without a theme deploy.
  // Falls back to the hardcoded defaults if the global is missing (dev/preview).
  try {
    var __mf = window.STIX_CRO_CONFIG && window.STIX_CRO_CONFIG[TEST_ID];
    if (__mf && __mf.variants && __mf.variants.length) {
      SPLIT = __mf.variants.map(function(v){ return {a: v.label, w: v.weight}; });
      VALID = {};
      __mf.variants.forEach(function(v){ VALID[v.label] = 1; });
      if (__mf.status === 'paused' || __mf.status === 'reverted') TEST_MODE = 'smoke';
      window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
      window.STIX_TEST_SOURCE[TEST_ID] = 'metafield';
    } else {
      window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
      window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded-fallback';
    }
  } catch (e) {
    window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
    window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded-fallback-error';
  }

  function gc(n){var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+n+'=([^;]*)'));return m?decodeURIComponent(m[1]):null;}
  function sc(n,v,d){var x=new Date();x.setTime(x.getTime()+d*86400000);document.cookie=n+'='+encodeURIComponent(v)+'; expires='+x.toUTCString()+'; path=/; SameSite=Lax';}
  function ovr(){try{var p=new URLSearchParams(location.search).get(PARAM);if(!p) return null; p=p.toLowerCase(); return VALID[p]?p:null;}catch(e){return null;}}
  function pick(){var r=Math.random()*100,c=0;for(var i=0;i<SPLIT.length;i++){c+=SPLIT[i].w;if(r<c)return SPLIT[i].a;}return SPLIT[0].a;}
  function isBot(){return /bot|crawl|spider|slurp|duckduckbot|baiduspider|yandex|bingpreview|facebookexternalhit|embedly|lighthouse|headlesschrome/i.test(navigator.userAgent||'');}
  function init(){
    if(!document.querySelector('[data-cl-xsell-router]')) return;
    var arm=ovr(), fromUrl=!!arm;
    if(!arm){
      if(TEST_MODE==='smoke') arm='control';
      else if(isBot()) arm='control';
      else{arm=gc(COOKIE); if(!arm||!VALID[arm]){arm=pick(); sc(COOKIE,arm,TTL);}}
    } else { sc(COOKIE,arm,TTL); }
    window.STIX_TEST=window.STIX_TEST||{}; window.STIX_TEST[TEST_ID]=arm;
    if (typeof window.stixCroExpose === "function") { window.stixCroExpose(TEST_ID, arm, { page_type: "pdp" }); }
    document.documentElement.setAttribute('data-cl-xsell-arm',arm);
    var track=(new URLSearchParams(location.search).get('cl_xsell_track')==='1');
    if(TEST_MODE==='live'||(fromUrl&&track)) fire(arm);
  }
    function fire(arm){
      // Delegates to the shared helper which handles:
      //   - cro_test_<id>=<arm> cart attribute
      //   - dataLayer.push (unconditional)
      //   - gtag('event','ab_test_exposure') with 5s retry
      //   - stix.track.exposeTest (Klaviyo + TW)
      // Helper is idempotent per (testId, arm), so safe to invoke twice
      // (once right after assignment, once from the legacy call site).
      if (typeof window.stixCroExpose === 'function') {
        window.stixCroExpose(TEST_ID, arm, { page_type: 'pdp' });
        return;
      }
      // Inline fallback if stix-cro-expose.js failed to load.
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'ab_test_exposure', cl_test_id: TEST_ID, cl_test_variant: arm,
          page_type: 'pdp', page_path: location.pathname
        });
      } catch (e) {}
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'attributes[cro_test_' + TEST_ID + ']=' + encodeURIComponent(arm),
          credentials: 'same-origin', keepalive: true
        }).catch(function(){});
      } catch (e) {}
    }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
